// extracted by mini-css-extract-plugin
module.exports = {"box":"box-11Y7CH51","rili":"rili-1z50qnj-"};